import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Plain';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/plain/PlainRegular.woff');
    }

    @font-face {
        font-family: 'Plain';
        font-weight: 700;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/plain/PlainBold.woff');
    }

    @font-face {
        font-family: 'Campton';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/campton/campton-medium-webfont.woff');
    }

    @font-face {
        font-family: 'Campton';
        font-weight: 700;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/campton/campton-bold-webfont.woff');
    }

    * {
        box-sizing: border-box;
    }

    html {
        font-size: 62.5%;
    }

    body {
        font-size: 1.6rem;
        font-family: 'Plain', Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0;
    }

    ul {
        margin: 0;
        padding: 0;
    }

    li {
        list-style-type: none;
    }

    a {
        color: #000;
    }
`;
